var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showModal)?_c('modal',{staticClass:"flash-modal",on:{"close":_vm.close}},[_vm._t("heading",null,{"slot":"title"}),_vm._v(" "),_vm._t("lead",null,{"slot":"lead"}),_vm._v(" "),_vm._t("body",null,{"slot":"body"})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }